export default class SelectMatch {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, selectionRank, numMatches }) {
    this.context.analytics.track('Customer Match - Match selected', { customerId, selectionRank, numMatches });
  }
}
